import { openQRDialog } from './qr-dialog';

/**
 * Delegated click handler for static QR images rendered via the
 * qala_qr_codes/action/render_qr_code action hook.
 *
 * Images that should not open the dialog carry a data-no-dialog attribute.
 */
document.addEventListener( 'click', e => {
	const img = e.target.closest( '.qala-qr-codes__qr-image' );

	if ( img && ! ( 'noDialog' in img.dataset ) ) {
		openQRDialog( img.src );
	}
} );
